import { InvoiceComponent } from "./../pages/finance/invoice/invoice.component";
import { CashComponent } from "./../pages/finance/cash/cash.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";
import { MainComponent } from "../pages/main/main.component";
import { AuthGuardService } from "../services/guards/auth-guard.service";
import { MainLayoutComponent } from "./main-layout/main-layout.component";
import { DashboardComponent } from "../pages/dashboard/dashboard.component";
import { CourseComponent } from "../pages/Institute/course/course.component";
import { ContractComponent } from "../pages/hrm/contract/contract.component";
import { RolesComponent } from "../pages/basic-information/roles/roles.component";
import { GroupComponent } from "../pages/basic-information/groups/group.component";
import { RegistrationComponent } from "../pages/registration/registration.component";
import { TermInfoComponent } from "../pages/Institute/term-info/term-info.component";
import { BranchComponent } from "../pages/basic-information/branch/branch.component";
import { HoldingComponent } from "../pages/basic-information/holding/holding.component";
import { CompanyComponent } from "../pages/basic-information/company/company.component";
import { CourseTypeComponent } from "../pages/Institute/course-type/course-type.component";
import { DegreeMajorComponent } from "../pages/basic-information/degree-major/degree-major.component";
import { CoursePatternComponent } from "../pages/Institute/course-pattern/course-pattern.component";
import { EducationPackageComponent } from "../pages/Institute/education-package/education-package.component";
import { PlacementTimeSheetComponent } from "../pages/Institute/placement-time-sheet/placement-time-sheet.component";
import { CompanyRegistrationComponent } from "../pages/Institute/company-registration/company-registration.component";
import { PlacementReservationComponent } from "../pages/placement-reservation/placement-reservation.component";
import { menuGuard } from "../services/guards/menu-guard.service";
import { CourseHistoryComponent } from "../pages/Institute/course-history/course-history.component";
import { ParrentTermComponent } from "../pages/Institute/parrent-term/parrent-term.component";
import { LevelInfoComponent } from "../pages/Institute/level-info/level-info.component";
import { LevelPrerequisiteComponent } from "../pages/Institute/level-info/level-prerequisite/level-prerequisitecomponent";
import { StaffComponent } from "../pages/Institute/staff/staff.component";
import { RoomListComponent } from "../pages/basic-information/rooms/room-list/room-list.component";
import { InvoiceSummaryComponent } from "../pages/finance/payment/invoice-summary/invoice-summary.component";
import { PaymentStatusComponent } from "../pages/finance/payment/payment-status/payment-status.component";
import { CourseSessionsCheckoutComponent } from "../pages/Institute/course/course-sessions-checkout/course-sessions-checkout.component";
import { CouponComponent } from "../pages/finance/coupon/coupon.component";
import { PackageEducationBranchComponent } from "../pages/Institute/education-package/package-education-branch/package-education-branch.component";
import { MarketerComponent } from "../pages/finance/marketer/marketer.component";
// import { PlacementReportComponent } from "../pages/report/placement-report/placement-report.component";
// import { RegistrationReportComponent } from "../pages/report/registration-report/registration-report.component";
import { DiscountGroupComponent } from "../pages/finance/discount-group/discount-group.component";
import { RegisterDirectFormComponent } from "../pages/account/register/register-direct-form/register-direct-form.component";
import { DiscountGroupPersonComponent } from "../pages/finance/discount-group-person/discount-group-person.component";
import { AccountsComponent } from "../pages/account/accounts/accounts.component";
import { ExceptionalCoefficientsComponent } from "../pages/Institute/exceptional-coefficients/exceptional-coefficients.component";
import { MarkManagementComponent } from "../pages/Institute/mark-management/mark-management.component";
import { StudentSessionsCheckoutComponent } from "../pages/sessions/student-sessions-checkout/student-sessions-checkout.component";
import { PaymnetConfirmationComponent } from "../pages/finance/payment/paymnet-confirmation/paymnet-confirmation.component";
import { SubsidiaryCompanyComponent } from "../pages/subsidiary/subsidiary-company/subsidiary-company.component";
import { SubsidiaryMemorandumComponent } from "../pages/subsidiary/subsidiary-memorandum/subsidiary-memorandum.component";
import { SubsidiaryContractComponent } from "../pages/subsidiary/subsidiary-contract/subsidiary-contract.component";
import { SubsidiaryCompanyAgentComponent } from "../pages/subsidiary/subsidiary-company-agent/subsidiary-company-agent.component";
import { MainLayoutSubsidiaryComponent } from "./main-layout-subsidiary/main-layout-subsidiary.component";
import { SubsidiaryDashboardContractStudentsComponent } from "../pages/subsidiary-dashboard/subsidiary-dashboard-contract/subsidiary-dashboard-contract-students/subsidiary-dashboard-contract-students.component";
import { CalenderManagementComponent } from "../pages/basic-information/company/calender-management/calender-management.component";
import { HolidayTypeComponent } from "../pages/Institute/holiday-type/holiday-type.component";
import { SubsidiaryStudentsComponent } from "../pages/subsidiary/subsidiary-students/subsidiary-students.component";
import { FinancialReportComponent } from "../pages/report/financial-report/financial-report.component";
import { EducationReportComponent } from "../pages/report/education-report/education-report.component";
import { SalaryReportComponent } from "../pages/report/salary-report/salary-report.component";
import { EduOrgReportComponent } from "../pages/report/edu-org-report/edu-org-report.component";
import { ManagementReportComponent } from "../pages/report/management-report/management-report.component";
import { SubsidiaryClassesComponent } from "../pages/subsidiary/subsidiary-classes/subsidiary-classes.component";
import { SubsidiaryDashboardContractClassesComponent } from "../pages/subsidiary-dashboard/subsidiary-dashboard-contract/subsidiary-dashboard-contract-classes/subsidiary-dashboard-contract-classes.component";
import { SubsidiaryDashboardContractFinancialComponent } from "../pages/subsidiary-dashboard/subsidiary-dashboard-contract/subsidiary-dashboard-contract-financial/subsidiary-dashboard-contract-financial.component";
import { StudentPrivateClassRequestComponent } from "../pages/Institute/student-private-class-request/student-private-class-request.component";
import { HomeComponent } from "../pages/home/home.component";
import { SurveyComponent } from "../pages/Institute/survey/survey.component";
import { GeneralGuideComponent } from "../pages/guidance/general-guide/general-guide.component";


const CoreRouteModule: Routes = [
  {
    path: "",
    component: HomeComponent
  },
  {
    path: "student",
    component: MainComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: "management",
    component: MainLayoutComponent,
    canActivate: [AuthGuardService, menuGuard]
  },
  {
    path: "guidance",
    children: [
      {
        path: '',
        component: GeneralGuideComponent
      }
    ]
  },
  {
    path: "management",
    component: MainLayoutComponent,
    canActivate: [AuthGuardService, menuGuard],
    children: [
      // {
      //   path: "",
      //   component: DashboardComponent
      // },
      {
        path: "basic",
        children: [
          {
            path: "holding",
            component: HoldingComponent,
            data: {
              breadcrumb: "holding",
              showCompanyButton: false
            }
          },
          // {
          //   path: "holding/company/:holdingId",
          //   component: CompanyComponent,
          //   data: {
          //     breadcrumb: "company"
          //   }
          // },
          // {
          //   path: "holding/company/branch/:companyId",
          //   component: BranchComponent,
          //   data: {
          //     breadcrumb: "branch"
          //   }
          // },
          {
            path: "company",
            component: CompanyComponent,
            data: {
              breadcrumb: "company",
              showCompanyButton: false
            }
          },
          {
            path: "company/branch",
            component: BranchComponent,
            data: {
              breadcrumb: "branch",
              showCompanyButton: false
            }
          },
          {
            path: "company/calenderManagement/:companyId",
            component: CalenderManagementComponent,
            data: {
              breadcrumb: "calenderManagement",
              showCompanyButton: false
            }
          },

          {
            path: "company/branch/roomList/:Bid",
            component: RoomListComponent,
            data: {
              breadcrumb: "roomsList",
              showCompanyButton: false
            }
          },
          {
            path: "groups",
            component: GroupComponent,
            data: {
              breadcrumb: "groups",
              showCompanyButton: true
            }
          },
          {
            path: "roles",
            component: RolesComponent,
            data: {
              breadcrumb: "roles",
              showCompanyButton: true
            }
          },
          {
            path: "majorList",
            component: DegreeMajorComponent,
            data: {
              breadcrumb: "majorList",
              showCompanyButton: true
            }
          }
        ],
        data: {
          breadcrumb: "basicInformation",
          showCompanyButton: true
        }
      },
      {
        path: "hrm",
        children: [
          {
            path: "personalcontract",
            component: ContractComponent,
            data: {
              breadcrumb: "personalContract",
              showCompanyButton: true
            }
          },
          {
            path: "subsidiary",
            children: [
              {
                path: "",
                component: SubsidiaryCompanyComponent,
                data: {
                  breadcrumb: "subsidiaryCompany",
                  showCompanyButton: true
                }
              },
              {
                path: "memorandum",
                component: SubsidiaryMemorandumComponent,
                data: {
                  breadcrumb: "memorandum",
                  showCompanyButton: true
                }
              },
              {
                path: "memorandum/:CustomerId",
                component: SubsidiaryMemorandumComponent,
                data: {
                  breadcrumb: "memorandum",
                  showCompanyButton: true
                }
              },
              {
                path: "companyAgent/:CustomerId",
                component: SubsidiaryCompanyAgentComponent,
                data: {
                  breadcrumb: "agent",
                  showCompanyButton: true
                }
              },
              {
                path: "contract",
                component: SubsidiaryContractComponent,
                data: {
                  breadcrumb: "contract",
                  showCompanyButton: true
                }
              },
              {
                path: "contract/:CustomerId",
                component: SubsidiaryContractComponent,
                data: {
                  breadcrumb: "contract",
                  showCompanyButton: true
                }
              },
              {
                path: "students/:ContractId",
                component: SubsidiaryStudentsComponent,
                data: {
                  breadcrumb: "students",
                  showCompanyButton: true
                }
              },
              {
                path: "classes/:ContractId",
                component: SubsidiaryClassesComponent,
                data: {
                  breadcrumb: "classes",
                  showCompanyButton: true
                }
              },

            ],
            data: {
              breadcrumb: "subsidiary",
              showCompanyButton: true
            }
          },
        ],
        data: {
          breadcrumb: "hrm",
          showCompanyButton: true
        }
      },
      {
        path: "institute",
        children: [
          {
            path: "survey",
            component: SurveyComponent,
            data: {
              breadcrumb: "survey",
              showCompanyButton: true
            }
          },
          {
            path: "coursepattern",
            component: CoursePatternComponent,
            data: {
              breadcrumb: "coursePattern",
              showCompanyButton: true
            }
          },
          {
            path: "coursetype",
            component: CourseTypeComponent,
            data: {
              breadcrumb: "courseType",
              showCompanyButton: true
            }
          },
          {
            path: "course",
            component: CourseComponent,
            data: {
              breadcrumb: "course",
              showCompanyButton: true
            }
          },
          {
            path: "educationpackage",
            component: EducationPackageComponent,
            data: {
              breadcrumb: "educationPackage",
              showCompanyButton: true
            }
          },
          {
            path: "packageeducationbranch/:packageId",
            component: PackageEducationBranchComponent,
            data: {
              breadcrumb: "educationPackage",
              showCompanyButton: true
            }
          },
          {
            path: "placementtimesheet",
            component: PlacementTimeSheetComponent,
            data: {
              breadcrumb: "placementTimeSheet",
              showCompanyButton: true
            }
          },
          {
            path: "companyregistration",
            component: CompanyRegistrationComponent,
            data: {
              breadcrumb: "companyRegistration",
              showCompanyButton: true
            }
          },

          {
            path: "terminfo",
            component: TermInfoComponent,
            data: {
              breadcrumb: "termInfo",
              showCompanyButton: true
            }
          },
          {
            path: "parentterm",
            component: ParrentTermComponent,
            data: {
              breadcrumb: "parentTerm",
              showCompanyButton: true
            }
          },
          {
            path: "coursehistory",
            component: CourseHistoryComponent,
            data: {
              breadcrumb: "courseHistory",
              showCompanyButton: true
            }
          },
          {
            path: "levelinfo/:packageId",
            component: LevelInfoComponent,
            data: {
              breadcrumb: "termInfo",
              showCompanyButton: true
            }
          },
          {
            path: "levelprerequisite/:packageId/:bid",
            component: LevelPrerequisiteComponent,
            data: {
              breadcrumb: "prerequisite",
              showCompanyButton: true
            }
          },
          {
            path: "holidayType",
            component: HolidayTypeComponent,
            data: {
              breadcrumb: "holidayType",
              showCompanyButton: true
            }
          },
          {
            path: "exceptionalcoefficients",
            component: ExceptionalCoefficientsComponent,
            data: {
              breadcrumb: "exceptionalCoefficients",
              showCompanyButton: true
            }
          },
          {
            path: "markmanagement",
            component: MarkManagementComponent,
            data: {
              breadcrumb: "markManagement",
              showCompanyButton: true
            }
          },
          {
            path: "staff",
            component: StaffComponent,
            data: {
              breadcrumb: "staff",
              showCompanyButton: true
            }
          }
        ],
        data: {
          breadcrumb: "institute",
          showCompanyButton: true
        }
      },
      {
        path: "placementreservation",
        component: PlacementReservationComponent,
        data: {
          breadcrumb: "placementReservation",
          showCompanyButton: true
        }
      },

      {
        path: "finance",
        children: [
          {
            path: "invoice",
            component: InvoiceComponent,
            data: {
              breadcrumb: "invoiceList",
              showCompanyButton: true
            }
          },
          {
            path: "invoiceSummary/:invoceId",
            component: InvoiceSummaryComponent,
            data: {
              breadcrumb: "invoiceSummary",
              showCompanyButton: true
            }
          },
          {
            path: "paymentStatus",
            component: PaymentStatusComponent
          },
          {
            path: "cash",
            component: CashComponent,
            data: {
              breadcrumb: "cashList",
              showCompanyButton: true
            }
          },
          {
            path: "coupon",
            component: CouponComponent,
            data: {
              breadcrumb: "coupon",
              showCompanyButton: true
            }
          },
          {
            path: "marketer",
            component: MarketerComponent,
            data: {
              breadcrumb: "marketer",
              showCompanyButton: true
            }
          },
          {
            path: "discountgroup",
            component: DiscountGroupComponent,
            data: {
              breadcrumb: "discountGroup",
              showCompanyButton: true
            },
          },
          {
            path: "discountperson",
            component: DiscountGroupPersonComponent,
            data: {
              breadcrumb: "discountperson",
              showCompanyButton: true
            }
          },
          {
            path: "discountGroupPerson",
            component: DiscountGroupPersonComponent,
            data: {
              breadcrumb: "discountGroupPerson",
              showCompanyButton: true
            }
          }

        ],
        data: {
          breadcrumb: "finance",
          showCompanyButton: true
        }
      },
      {
        path: "studentsessionscheckout",
        component: StudentSessionsCheckoutComponent,
        data: {
          breadcrumb: "studentSessionsCheckout",
          showCompanyButton: true
        }
      },
      {
        path: "register",
        children: [
          {
            path: "companyregistration",
            component: CompanyRegistrationComponent,
            data: {
              breadcrumb: "instituteRegistrationList",
              showCompanyButton: true
            }
          },
          {
            path: "companyregistration/:nationalCode",
            component: CompanyRegistrationComponent,
            data: {
              breadcrumb: "companyRegistration",
              showCompanyButton: true
            }
          },

          {
            path: "registration",
            component: RegistrationComponent,
            data: {
              breadcrumb: "registration",
              showCompanyButton: true
            }
          }
        ],
        data: {
          breadcrumb: "register",
          showCompanyButton: true
        }
      },
      {
        path: "report",
        children: [
          // {
          //   path: "placementreport",
          //   component: PlacementReportComponent,
          //   data: {
          //     breadcrumb: "placementReport",
          //     showCompanyButton: true
          //   }
          // },
          // {
          //   path: "registrationreport",
          //   component: RegistrationReportComponent,
          //   data: {
          //     breadcrumb: "registrationReport",
          //     showCompanyButton: true
          //   }
          // }
          // ,
          {
            path: "financial-report",
            component: FinancialReportComponent,
            data: {
              breadcrumb: "financialReport",
              showCompanyButton: true
            }
          }
          ,
          {
            path: "education-report",
            component: EducationReportComponent,
            data: {
              breadcrumb: "EducationReport",
              showCompanyButton: true
            }
          }
          ,
          {
            path: "salary-report",
            component: SalaryReportComponent,
            data: {
              breadcrumb: "SalaryReport",
              showCompanyButton: true
            }
          },
          {
            path: "edu-org-report",
            component: EduOrgReportComponent,
            data: {
              breadcrumb: "EduOrgReport",
              showCompanyButton: true
            }
          },
          {
            path: "management-report",
            component: ManagementReportComponent,
            data: {
              breadcrumb: "ManagementReport",
              showCompanyButton: true
            }
          }
        ],
        data: {
          breadcrumb: "report",
          showCompanyButton: true
        }
      },
      //{
      //  path: "autoattendance/:company/:branch/:terminfo",
      //  component: CourseSessionsCheckoutComponent,
      //  data: {
      //    breadcrumb: "attendance",
      //    showCompanyButton: true
      //  }
      //},
      {
        path: "registerdirect",
        component: RegisterDirectFormComponent,
        data: {
          breadcrumb: "registerdirect",
          showCompanyButton: true
        }
      },
      {
        path: "request-private-class",
        component: StudentPrivateClassRequestComponent,
        data: {
          breadcrumb: "requestPrivateClass",
          showCompanyButton: true
        }
      },
      {
        path: "accounts",
        component: AccountsComponent,
        data: {
          breadcrumb: "users",
          showCompanyButton: true
        }
      },
      {
        path: "attendance",
        component: CourseSessionsCheckoutComponent,
        data: {
          breadcrumb: "attendance",
          showCompanyButton: true
        }
      },
      //All subsidiary Route Addresses //

      { path: "dashboard", component: DashboardComponent }


    ]

  },
  {
    path: "pay/confirmation/:InvoiceOnlinePaymentId",
    component: PaymnetConfirmationComponent,
  },


  // All subsidairy Route Addresses
  // MainLayoutSubsidiaryComponent
  {
    path: "subsidiary",
    component: MainLayoutSubsidiaryComponent,
    canActivate: [AuthGuardService]
  },
  {
    path: "subsidiary",
    component: MainLayoutSubsidiaryComponent,
    canActivate: [AuthGuardService],
    children: [

      {
        path: "contract",
        children: [

          {
            path: "students/:ContractId",
            component: SubsidiaryDashboardContractStudentsComponent,
            data: {
              breadcrumb: "students",
              showCompanyButton: true
            }
          },
          {
            path: "classes/:ContractId",
            component: SubsidiaryDashboardContractClassesComponent,
            data: {
              breadcrumb: "classes",
              showCompanyButton: true
            }
          },
          {
            path: "financial/:ContractId",
            component: SubsidiaryDashboardContractFinancialComponent,
            data: {
              breadcrumb: "classes",
              showCompanyButton: true
            }
          }
        ],
        data: {
          breadcrumb: "contract",
          showCompanyButton: true
        }
      }


    ]

  },

];

@NgModule({
  imports: [RouterModule.forChild(CoreRouteModule)],
  exports: [RouterModule]
})
export class coreRoutingModule { }
